const state = {
	offices: null,
	sel_continent: 3,
	change_continent: false,
};

const getters = {
	offices: (state) => state.offices,
	getSelectedContinent: state => state.sel_continent,
	getChangeContinent: state => state.change_continent,
};

const actions = {
	fetchOfficesData({ commit }, params = null) {

		console.log(params);

		window.axios.get('/offices', {
			params: params,
		}).then(function (response) {
			commit('setOfficesData', response.data);
		})
	},
};

const mutations = {
	setOfficesData(state, officesData) {
		state.offices = officesData;
	},
	setSelectedContinent(state, data) {
		state.sel_continent = data
	},
	setChangeContinent(state, data) {
		state.change_continent = data
	}
};

export default {
	state,
	getters,
	actions,
	mutations,
}
